<template>
  <div class="d-flex flex-column align-end">
    <div class="d-flex justify-end" style="gap: .25rem;">
      <router-link
        v-if="model"
        :class="{ 'white--text': $vuetify.theme.dark }"
        :to="{path: '/location', query: { textSearch: model.title, includeHistory: true}}"
      >
        <div>
          {{ model.title }}
        </div>
      </router-link>
      <v-tooltip
        v-if="model"
        bottom
      >
        <template #activator="{ on, attrs }">
          <v-icon
            small
            style="cursor:help"
            v-bind="attrs"
            color="grey"
            v-on="on"
          >
            mdi-information-outline
          </v-icon>
        </template>
        <span>
          <div v-if="model.address">
            {{ model.address }}
          </div>
          <div v-if="model.country">
            {{ model.country }}
          </div>
          <div v-if="model.notes">
            {{ model.notes }}
          </div>
        </span>
      </v-tooltip>
    </div>
    <div v-if="model.contactName || model.contactEmail || model.contactPhone" class="my-3 darkgrey--text">
      <div v-if="model.contactName">
        <ClipboardCopy>
          {{ model.contactName }}
        </ClipboardCopy>
        <v-icon small>
          mdi-account-outline
        </v-icon>
      </div>
      <div v-if="model.contactEmail">
        <ClipboardCopy>
          {{ model.contactEmail }}
        </ClipboardCopy>
        <v-icon small>
          mdi-email-outline
        </v-icon>
      </div>
      <div v-if="model.contactPhone">
        <ClipboardCopy>
          {{ model.contactPhone }}
        </ClipboardCopy>
        <v-icon small>
          mdi-phone-outline
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import ClipboardCopy from './ClipboardCopy.vue';

export default {
  name: 'LocationLink',
  components: {
    ClipboardCopy
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      model: null
    }
  },
  mounted() {
    this.$api.get(`location/link/${this.id}`).then((response) => {
      this.model = response.data;
    });
  }
}
</script>